import { useCallback, useState } from "react";
import { RelatorioReceitasQueryParams } from "core/features/relatorios/typings/index";
import moment from "moment";

export const defaultFiltroRelatorioReceitas: RelatorioReceitasQueryParams = {
  search: "",
  dataInicio: moment().startOf("month").format("YYYY-MM-DD"),
  dataFim: moment().endOf("month").format("YYYY-MM-DD"),
  centrosDeCustoIds: undefined,
  contasBancariasIds: undefined,
};

function useFiltroRelatorioReceitas() {
  const [filtro, setFiltro] = useState<RelatorioReceitasQueryParams>(
    defaultFiltroRelatorioReceitas
  );

  const onChangeFiltro = useCallback(
    (_filtro: Partial<RelatorioReceitasQueryParams>) => {
      setFiltro((state) => ({ ...state, ..._filtro }));
    },
    []
  );

  const onResetFiltro = useCallback(() => {
    setFiltro(defaultFiltroRelatorioReceitas);
  }, []);

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
    onResetFiltro,
  };
}

export default useFiltroRelatorioReceitas;
